import { WordpressContent } from "../types/wordpress";
import { wordpressDataSortByDate } from "../utils/wordpressDataSorter";
import { logger } from "@origin-digital/reporting-client";
import { ProofPointItem } from "../context/ProofPointsContext";

const LPG_OFFERS_PROOF_POINTS_ENDPOINT =
  "/wp-json/oe/json-object/v1/lpg/lpgplans/proofpoints";
const PROOF_POINTS_TIMEOUT = TAL.config.minimumLoadingTime + 1000; // minimum loading time allowed for offers

export async function fetchProofPoints() {
  try {
    const response = await fetch(LPG_OFFERS_PROOF_POINTS_ENDPOINT, {
      signal: AbortSignal.timeout(PROOF_POINTS_TIMEOUT),
    });
    const jsonObjects = (await response.json()) as WordpressContent<
      ProofPointItem[]
    >[];
    const sortedProofpoints = wordpressDataSortByDate(jsonObjects);
    return sortedProofpoints[0]?.json_content;
  } catch (error) {
    // ignore and dont show proof points - due to error or timeout
    logger.warn("Failed to fetch proof points", error);
    return [];
  }
}
